var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'd-flex': true,
    'justify-space-around': _vm.justify == 'space-around',
    'justify-space-between': _vm.justify == 'space-between',
    'flex-column': _vm.vertical,
    'flex-gap-3': _vm.vertical,
  }},[(_vm.noRatingsFound)?_c('p',{staticClass:"no-ratings-found"},[_vm._v("no ratings found")]):_vm._e(),_vm._l((Object.keys(_vm.ratings).filter((key) => _vm.ratings[key].score != undefined)),function(ratingSet){return _c('div',{key:ratingSet,class:{
      'rating-info': true,
    }},[_c('rating-circle-colored-ring',{attrs:{"rating":_vm.ratings[ratingSet].score,"size":_vm.ratingCircleSize}}),(_vm.ratings[ratingSet].count)?_c('p',{staticClass:"rating-count"},[_vm._v("\n      "+_vm._s(_vm.ratings[ratingSet].count.toLocaleString())+"\n      ratings\n    ")]):_vm._e(),_c('p',{staticClass:"rating-set-label"},[_vm._v(_vm._s(ratingSet))])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }